import * as React from "react";
import {
  Block,
  Page,
  Navbar,
  Link,
  BlockTitle,
  Popup,
  NavRight,
  Input,
  Label,
  List,
  ListItem,
  Row,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
  Col,
  Icon,
} from "framework7-react";
import { API_URL, CLOUD_FUNCTION, POST_FILTER } from "src/utils/constants";
import { api, now } from "src/utils/utils";
import { EventEmmiter } from "src/utils/events.js";

export default class NewCompetitor extends React.Component {
  public state = {
    link: "",
    competitor: null as any,
  };

  constructor(props: {} | Readonly<{}>) {
    super(props);
    this.reset();
  }

  public reset = () => {
    this.setState({ link: "", competitor: null });
  };

  public render() {
    return (
      <Popup className="new-competitor-popup" closeByBackdropClick={false}>
        <Page>
          <Navbar title="Nuevo Competidor">
            <NavRight>
              <Link className="closeOrder" popupClose>
                <i className="icon icon-x" />
              </Link>
            </NavRight>
          </Navbar>
          <BlockTitle>
            Los campos marcados con ( * ) son obligatorios.
          </BlockTitle>
          <form onSubmit={this.readLink}>
            <List>
              <ListItem className={"bg-white"}>
                <Label>* Enlace de Mercadolibre</Label>
                <Input
                  type="url"
                  required={true}
                  value={this.state.link}
                  validate
                  onChange={(e: any) =>
                    this.setState({
                      link: e.target.value,
                    })
                  }
                  placeholder="https://www.mercadolibre.com.mx/perfil/NOMBRE-COMPETIDOR"
                />
              </ListItem>
            </List>
            <Block>
              {this.state.competitor !== null ? (
                <Card outline={true}>
                  <CardHeader>
                    <div className="fb">{this.state.competitor.storeName}</div>
                  </CardHeader>
                  <CardContent padding={false}>
                    <Row>
                      <Col width="100">
                        <List mediaList>
                          <ListItem
                            header="Reputación"
                            text="MercadoLíder Platinum"
                            subtitle={
                              this.state.competitor.totalSales +
                              " ventas en los últimos 365 días"
                            }
                          />
                          <ListItem
                            subtitle={"✅ " + this.state.competitor.metric1}
                          />
                          <ListItem
                            subtitle={"✅ " + this.state.competitor.metric2}
                          />
                          <ListItem
                            header="Total Opiniones"
                            subtitle={this.state.competitor.buyersFeedback}
                          />
                        </List>
                      </Col>
                      <Col width="33">
                        <List mediaList>
                          <ListItem
                            header="Ops. Buenas"
                            subtitle={this.state.competitor.feedbackGood}
                          />
                        </List>
                      </Col>
                      <Col width="33">
                        <List mediaList>
                          <ListItem
                            header="Ops. Regulares"
                            subtitle={this.state.competitor.feedbackRegular}
                          />
                        </List>
                      </Col>
                      <Col width="33">
                        <List mediaList>
                          <ListItem
                            header="Ops. Malas"
                            subtitle={this.state.competitor.feedbackBad}
                          />
                        </List>
                      </Col>
                    </Row>
                  </CardContent>
                  <CardFooter>
                    <div>
                      <Icon slot="media" icon="icon icon-map-pin icon-sm" />
                      {this.state.competitor.ubication}
                    </div>
                  </CardFooter>
                </Card>
              ) : (
                false
              )}
            </Block>
            <Block strong className={"bg-white"}>
              <Row tag="p">
                {/* <Button popupClose className="col">
                  <div className="fb">Cancelar</div>
                </Button> */}
                {this.state.competitor === null ? (
                  <button className="col customButton_1 fb button button-fill">
                    Siguiente
                  </button>
                ) : (
                  <button className="col customButton_1 fb button button-fill">
                    Guardar Competidor
                  </button>
                )}
              </Row>
            </Block>
          </form>
        </Page>
      </Popup>
    );
  }

  public readLink = async (event: any) => {
    event.preventDefault();

    if (this.state.competitor === null) {
      if (
        this.state.link.indexOf("https://www.mercadolibre.com.mx/perfil/") ===
        -1
      ) {
        this.$f7?.toast
          .create({
            text: "Ingresa un enlace de perfil válido",
            position: "center",
            closeTimeout: 2000,
          })
          .open();
      } else {
        this.$f7?.dialog.preloader("Extrayendo datos de Mercado Libre");

        const data = (await api.post(
          API_URL + CLOUD_FUNCTION + "getCompetitor",
          {
            link: this.state.link,
          }
        )) as any;

        this.setState({
          competitor: {
            link: this.state.link,
            storeName: this.getValue(data.toString(), "storeName"),
            yearsSelling: this.getValue(data.toString(), "yearsSelling"),
            totalSales: this.getValue(data.toString(), "totalSales"),
            ubication: this.getValue(data.toString(), "ubication"),
            leaderStatus: this.getValue(data.toString(), "leaderStatus"),
            metric1: this.getValue(data.toString(), "metric1"),
            metric2: this.getValue(data.toString(), "metric2"),
            buyersFeedback: this.getValue(data.toString(), "buyersFeedback"),
            feedbackGood: this.getValue(data.toString(), "feedbackGood"),
            feedbackRegular: this.getValue(data.toString(), "feedbackRegular"),
            feedbackBad: this.getValue(data.toString(), "feedbackBad"),
            linkPublications: this.getValue(
              data.toString(),
              "linkPublications"
            ),
            createdAt: now(),
            status: 1,
          },
        });
        console.log(this.state);

        // const dataStr = JSON.stringify(data);
        // const dataSplit = dataStr.split("__PRELOADED_STATE__ = ")[1] as string;
        // const PRELOAD = dataSplit.replace(/\\/g, "");
        // const a = PRELOAD.split(";n");
        // const b = a[0].replace(/"Mercado Libre""."/gi, "");
        // console.log(b);

        this.$f7?.dialog.close();
      }
    } else {
      this.$f7?.dialog.preloader("Guardando Competidor");
      const filter = { table: "competitors" };
      const competitorSaved = (await api.post(
        API_URL + POST_FILTER + encodeURIComponent(JSON.stringify(filter)),
        this.state.competitor
      )) as any;

      EventEmmiter.dispatch("competitorAdded", competitorSaved);
      this.$f7?.dialog.close();
      this.$f7?.popup.close(".new-competitor-popup");
      this.$f7?.toast
        .create({
          text:
            "Competidor " +
            this.state.competitor.storeName +
            " guardado con éxito.",
          position: "center",
          closeTimeout: 2500,
        })
        .open();
      this.reset();
    }
  };

  public getValue(data: string, key: string): any {
    let value;
    let cutValue;
    let finalValue;
    switch (key) {
      case "storeName":
        value = data.split(
          '<h3 id="store-info__name" class="store-info__name">'
        );
        cutValue = value[1].split("</h3>");
        finalValue = cutValue[0];
        return finalValue;
        break;

      case "yearsSelling":
        value = data.split('<p class="experience"><span><span>');
        cutValue = value[1].split("</span>");
        finalValue = cutValue[0];
        return Number(finalValue);
        break;

      case "totalSales":
        value = data.split(
          '<p class="seller-info__subtitle-sales"><span><span>'
        );
        cutValue = value[1].split("</span>");
        finalValue = cutValue[0];
        return Number(finalValue);
        break;

      case "leaderStatus":
        value = data.split('</svg><p class="message__title">');
        cutValue = value[1].split("</p>");
        finalValue = cutValue[0];
        return finalValue;
        break;

      case "ubication":
        value = data.split('</h3><p class="location-subtitle">');
        cutValue = value[1].split("</p>");
        finalValue = cutValue[0];
        return finalValue;
        break;

      case "metric1":
        value = data.split(
          '<div class="metric__drawing metric__drawing--well-claim"></div><div class="metric__description"><h2>'
        );
        cutValue = value[1].split("</h2>");
        finalValue = cutValue[0];
        return finalValue;
        break;

      case "metric2":
        value = data.split(
          '<div class="metric__drawing metric__drawing--well-delivery"></div><div class="metric__description"><h2>'
        );
        cutValue = value[1].split("</h2>");
        finalValue = cutValue[0];
        return finalValue;
        break;

      case "buyersFeedback":
        value = data.split(
          '<div class="buyers-feedback__wrapper"><span class="total">'
        );
        cutValue = value[1].split("</span>");
        finalValue = cutValue[0];
        return finalValue;
        break;

      case "feedbackGood":
        value = data.split(
          '<span id="feedback_good" class="buyers-feedback-qualification">'
        );
        cutValue = value[1].split("</span>");
        finalValue = cutValue[0];
        finalValue = finalValue.match(/\d/g);
        if (finalValue != null) {
          const FINAL = finalValue.join("");
          return Number(FINAL);
        }
        break;

      case "feedbackRegular":
        value = data.split(
          '<span id="feedback_good" class="buyers-feedback-qualification">'
        );
        cutValue = value[2].split("</span>");
        finalValue = cutValue[0];
        finalValue = finalValue.match(/\d/g);
        if (finalValue != null) {
          const FINAL = finalValue.join("");
          return Number(FINAL);
        }
        break;

      case "feedbackBad":
        value = data.split(
          '<span id="feedback_good" class="buyers-feedback-qualification">'
        );
        cutValue = value[3].split("</span>");
        finalValue = cutValue[0];
        finalValue = finalValue.match(/\d/g);
        if (finalValue != null) {
          const FINAL = finalValue.join("");
          return Number(FINAL);
        }
        break;

      case "linkPublications":
        value = data.split('<a class="publications__subtitle" href="');
        cutValue = value[1].split('"><span>');
        finalValue = cutValue[0];
        return finalValue;
        break;

      default:
        return "";
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/prefabs/NewCompetitor.tsx